export enum SessionState {
  IDLE = 0,
  ACTIVE = 1,
  MEASURING = 2,
  TERMINATED = 3,
}

export interface ScanVitalValue {
  value?: number | null;
  isEnabled?: boolean;
}

export interface ScanVitalSigns {
  pulseRate: ScanVitalValue;
  respirationRate: ScanVitalValue;
  stress?: ScanVitalValue;
  hrvSdnn?: ScanVitalValue;
  spo2?: ScanVitalValue;
  bloodPressure?: ScanVitalValue;
}

export type MedsiScanVitalSigns = ScanVitalSigns & {
  [key: string]: ScanVitalValue | undefined;
};
